/** Deterministic display IDs for mandates and screenplays (no backend change). */

function hashToDigits(input: string, length: number): string {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) >>> 0;
  }
  const max = 10 ** length;
  const num = hash % max;
  return String(num).padStart(length, '0');
}

export function formatMandateId(projectId: string): string {
  return `MND-${hashToDigits(projectId, 4)}`;
}

export function formatScriptId(sessionId: string): string {
  return `SCR-${hashToDigits(sessionId, 5)}`;
}
